import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
// import { Modal } from 'antd';
import {Item} from '@/components/core';
import { Swiper, SwiperSlide } from 'swiper/react';
// const { confirm } = Modal;
import Modal from 'react-modal';


const Header = props => {
  const isConsulting = window.location.href.indexOf('/consulting') > -1 ? true : false
  const config = {
    // title: <a href="/" className="item-logo"><i className="icon-logo header-logo"></i></a>,
    title: <a href="/" className="item-logo"><img style={{width:'150px'}} alt='明心数智-logo' src="/images/logo-1.png" /></a>,
    '@list': {
      data: adapter(menusData),
      listClass: 'item-menus' 
    },
    // body: [
    //   { title: <a href="javascript:;">产品中心</a>, itemClass: 'item-li'},
    //   { title: <a href="javascript:;">客户案例</a>, itemClass: 'item-li'},
    //   { title: <a href="">关于明心</a>, itemClass: 'item-li'},
    // ],
    footer: !isConsulting ? [{
      title: '立即咨询',
      itemClass: 'ss-button btn-default plain small',
      url: '/consulting'
    }] : [],
    // bodyClass: 'item-menus',
    footerClass: 'ml-auto',
    itemClass: 'pages-header'
  }
  return (
    <Item {...config} />
  )
}

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, .3)'
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    background: 'transprent',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: '1200px',
    maxHeight: '675px',
    padding: '0',
    border: 'none',
    overflow: 'hidden'
  },
};

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');
const Banner = props => {
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [url, setUrl] = React.useState('');
  const {data} = props
  function onBannerBtn (e,  ii) {
    let _url = ii === 0 ? 'https://mxsk-ui.oss-cn-shenzhen.aliyuncs.com/MXwebside/video/MX_video.mp4' : 'https://mxsk-ui.oss-cn-shenzhen.aliyuncs.com/MXwebside/video/CMP_video.mp4'
    setUrl(_url)
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }
  
  return (
    <>
      <Swiper
        className="pages-banner"
        // onSlideChange={() => console.log('slide change')}
        // onSwiper={(swiper) => console.log(swiper)}
      >
        { data.length > 0 && data.map((item, idx) => {
          item.showButton = item.showButton !== false ? true : false
          const _btnTypeArry = item.showButton ? item.content.buttonType.split(',') : []
          return (
            <SwiperSlide key={'banner-'+idx} >
              <img className="item-pic" src={item.img} />
              {
                item.content ? (
                  <div className={"item-body " + item.content.className}>
                    <div className="wid1200">
                      <div className="item-title">{item.content.title}</div>
                      {item.content.desc ? <div className="item-desc">{item.content.desc}</div> : ''}
                      {
                        item.showButton ? 
                          item.content.buttonText.split(',').map((it, i) => {
                            return (
                              _btnTypeArry[i] === 'modal' ?
                              <button className="ss-button btn-default" onClick={(e) => onBannerBtn(e, i)} key={i}>{it}<i className="icon-play"></i></button> : 
                              <a href='/consulting' className="ss-button btn-default" key={i}>{it}</a>
                            )
                          })
                        : ''
                      }
                    </div>
                  </div>
                ) : null
              }
            </SwiperSlide>
          )
        }) }
      </Swiper>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
      >
        <video src={url} controls="controls" autoPlay="autoplay"  controlsList="nodownload">
          您的浏览器不支持 video 标签。
        </video>
        <i className="item-close icon-clear" onClick={closeModal}></i>
      </Modal>
    </>
  )
}

// const Modals = props => {
//   console.log(props, '===== modal');
//   // const handleOk = () => {
//   //   setIsModalOpen(false);
//   // };

//   // const handleCancel = () => {
//   //   setIsModalOpen(false);
//   // };
//   return (
//     <Modal title="Basic Modal" open={props.open} >
//       <video src="movie.ogg" controls="controls">
//         您的浏览器不支持 video 标签。
//       </video>
//     </Modal>
//   )
// }

const Footer = props => {
  let scrollBtnShow = true
  let canScroll = true
  const footerContactCfg = {
    title: <img src="/images/consulting-bg.jpg" className="item-pic" />,
    body: [
      { title: "开启AI数智化新时代", itemClass: 'item-title' },
      { title: <a href="/consulting" className='ss-button btn-fff'>立即咨询</a>},
    ],
    itemClass: 'pages-footer-contact',
    bodyClass: 'item-wrap'
  }
  const footerCfg = {
    '@list': {
      data: adapterFooter(menusData),
      listClass: 'footer-top'
    },
    body: [
      { title: <i className="icon-logo footer-logo"></i> },
      { title: 'Copyright©️ 2020-2026 深圳市明心数智科技有限公司 版权所有' },
      { title: <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/recordQuery" className='footer-copy'><p >粤ICP备2020104261号</p></a>},
      { title: <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502008100" className='footer-copy'><img src='/images/footer-icon.png'/><p >粤公网安备 44030502008100号</p></a>}
      // { title: <p className="footer-copy"><img src='/images/footer-icon.png'/>粤公网安备 44030502008100号</p> },
    ],
    bodyClass: 'footer-bottom',
    itemClass: 'wid1200'
  }
  const fixedBtnCfg = {
    title: <a href="/consulting" className="item-contact"><i className="icon-contact"></i><span className="item-title">联系我们</span></a>,
    // body: [
    //   { title: <i className="icon-contact"></i> },
    //   { title: <a href="/consulting">联系我们</a>, itemClass: 'item-title' }
    // ],
    dot: [{
      title: <i className="icon-top"></i>,
      itemClass: 'item-top',
      onClick(e) {
        // window.scrollTo(0, 0)
        // 按钮处于显示状态 并且滚动方法处于空闲中
        if (scrollBtnShow && canScroll) {
          // 开始执行
          canScroll = false
          // 获取到页面顶部的距离
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
          // 实现需求：任何高度的页面都将在100步以内滚动完毕
          // 实现过程：
          // 加速时的路程走一半减速时的路程走一半 (scrollTop / 2)
          // 加速滚动公式 1x+2x+3x = scrollTop / 2 减速同理
          // 高斯求和可得：x=(scrollTop / 2)/1275
          const biansuAtr = (scrollTop / 2) / 1275 + 10
          let scrollLength = 0
          // 加速步
          let jiasuStep = 0
          // 减速步
          let jiansuStep = 50
          let test = 0
          const timer = setInterval(() => {
            if (jiasuStep >= 50) {
              // 减速
              scrollLength = scrollLength + biansuAtr * jiansuStep
              test = test + biansuAtr * jiansuStep
              jiansuStep--
              if (jiansuStep === 0) {
                scrollLength = scrollTop
              }
            } else {
              // 加速
              jiasuStep++
              scrollLength = scrollLength + biansuAtr * jiasuStep
            }
            window.scrollTo(0, scrollTop - scrollLength)
            // 滚动到顶部 清除定时器
            if (scrollTop - scrollLength <= 0) {
              canScroll = true
              clearInterval(timer)
            }
          }, 15)
        }
      }
    }],
    // bodyClass: 'item-contact',
    itemClass: 'pages-fixed-right'
  }
  return (
    <>
      <Item {...footerContactCfg} />
      <div className='pages-footer'>
        <Item {...footerCfg} />
      </div>
      <Item {...fixedBtnCfg} />
    </>
  )
}


const Pager = (props) => {
  
  const {header, banner, body, bodyfooter, footer} = props
  const HeaderWrap = header || <Header />
  const BannnerWrap = banner ? <Banner {...banner} /> : null
  const BodyWrap = body || null
  const BodyFooterWrap = bodyfooter || null
  const FooterWrap = footer || <Footer />
  // const ModalWrap = <Modals {...open} />
  return (
    <div className="pager">
      {HeaderWrap}
      {BannnerWrap}
      {BodyWrap}
      {BodyFooterWrap}
      {FooterWrap}
      {/* {ModalWrap} */}
    </div>
  )
}


var menusData = [
  // {
  //   title: '产品中心',
  //   type: 'product',
  //   child: [
  //     { title: '产融管理运营平台', type: 'cmp' },
  //     { title: '跨境经营评估平台', type: 'fap' },
  //     { title: '产融方案设计平台', type: 'srp' },
  //     { title: '经营评估平台', type: 'oap' },
  //     { title: '产业物联网平台', type: 'imp' },
  //     { title: '产业区块链平台', type: 'bmp' },
  //   ]
  // },
  // {
  //   title: '客户案例',
  //   type: 'case',
  //   child: [
  //     { title: '纺织行业', type: 'textile-industry' },
  //     { title: '汽车行业', type: 'motor-dom' },
  //     { title: '跨境行业', type: 'cross-border' },
  //     { title: '玻璃行业', type: 'glass-industry' },
  //     { title: 'MRO行业', type: 'mro' },
  //     { title: '零售电商行业', type: 'retail-e-commerce' },
  //     { title: '塑料包装行业', type: 'plastic-packaging' },
  //   ]
  // },
  {
    title: '关于明心',
    type: 'about',
    child: [
      { title: '企业简介', type: 'index' },
      { title: '联系我们', type: 'contact' },
      { title: '新闻中心', type: 'news' },
      { title: '加入我们', type: 'join'},
    ]
  },
  {
    title: 'AI产品中心',
    type: 'newProduct',
    child: [
      { title: '跨境财税合规 ', type: 'fap' },
      { title: '产业经营评估', type: 'cmp' },
      { title: '优选智能物流', type: 'wl' },
      { title: '达人营销管理', type: 'dr' },
    ]
  },
  {
    title: '数据支撑与架构',
    type: 'dataSupport',
    child: [
      { title: '数据支撑', type: 'support' },
      { title: '数据架构', type: 'architecture' },
    ]
  },
]

var adapter = (data, name = 'menus') => {
  // let pathname = window.location.pathname
  return data.map(item => {
    return {
      title: {title: item.title, itemClass: name +'-title'},
      body: item.child.map( it => {
        const url = (item.type === 'product' ? '/product?' : item.type === 'newProduct' ? '/newProduct?' : item.type === 'dataSupport' ? '/dataSupport?' : item.type === 'case' ? '/case?' : '/about?') + it.type
        // const url = item.type+'#' + it.type
        return {
          title: <a href={url}>{it.title}</a>,
          itemClass: 'item-li'
        }
      }),
      itemClass: name+ '-li',
      bodyClass: name+ '-body',
    }
  })
}

var adapterFooter = (data) => {
  let output = adapter(data, 'footer')
  const address = '深圳市南山区粤海街道深圳湾科技生态园\n12栋B座50楼'
  output.push({
    title: [
      { title: '关注或联系我们', itemClass: 'mb-default' },
      { title: '添加明心数智公众号', itemClass: 'mb-primary' },
      { title: <img src="/images/qrcode.jpg" className="item-pic mb-default" style={{ width:'126px' }}/>},
    ],
    body: [
      { title: '联系电话：', dot: [{title: '0755-86199719'}], itemClass: 'item-p' },
      { title: '电子邮箱：', dot: [{title: 'mingxinsk@mingxinsk.com'}], itemClass: 'item-p' },
      { title: '联系地址：', dot: [{title: <pre>{address}</pre>}], itemClass: 'item-p' },
    ],
    bodyClass: 'item-contact',
    itemClass: 'footer-right'
  })
  return output
}


export default Pager